<template>
    <div class="mb-3">
        <label :for="id" v-if="!!label"
            >{{ label }}
            <span v-if="required" class="field-required-mark">*</span></label
        >
        <v-select
            :id="id"
            v-bind="$attrs"
            v-on="$listeners"
            :options="theOptions"
            :reduce="item => (!getObject ? item.code : item)"
            @input.once="react"
            :label="labelProp"
        ></v-select>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: () => `select-${Math.random() * 1000000000}`,
        },
        keyProp: {
            type: String,
            default: 'id',
        },
        labelProp: {
            type: String,
            default: 'name',
        },
        items: {
            type: Array,
            default: () => [],
        },
        getObject: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        theOptions() {
            return this.items.map(item => ({
                ...item,
                label: item[this.labelProp],
                code: item[this.keyProp],
            }))
        },
    },
    methods: {
        react(val) {
            this.$emit('change', val)
        },
    },
}
</script>
